<template>
  <div ref="ipData" id="ipData" :class="activateComparison ? 'dataTables activateComparison' : 'dataTables'">
    <el-table ref="coderTable" v-if="grouping === '1'" key="byCoderIp" :data="isIE11 ? coderTablePagination : coderTableData" empty-text="No Coder Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <div :class="`coder_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'coder', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.coder)" v-html="highlightValue(scope.row.coder, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)" v-html="highlightValue(scope.row.totalRecords, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'coder', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'coder', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'coder', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Code', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'coder', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'coder', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'coder', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'coder', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-if="scope.row.poaCodes" v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coder_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'coder', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`coder_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'coder', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <!-- <span :class="scope.row.reimbDiff < 0 ? 'negative' : ''">{{moneyFormatter(scope.row.reimbDiff)}}</span> -->
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="coderTrendingTable" v-if="grouping === '19'" key="byCoderTredningIp" :data="isIE11 ? coderTrendingTablePagination : coderTrendingTableData" empty-text="No Coder Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="coder" label="Coder" sortable>
        <template slot-scope="scope">
          <!-- <div :class="`coderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Coder Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'coderTrending', prop: 'coder', index: scope.$index, row: scope.row })" v-html="highlightValue(scope.row.coder, filterCriteria)"></div> -->
          <div v-html="highlightValue(scope.row.coder, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :class="`coderTrending_coder_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'coderTrending', prop: 'coder', index: scope.$index, row: scope.row }, $event, scope.row.projectName)" v-html="highlightValue(scope.row.projectName, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div title="View Account Numbers" class="details" @click="buildAccountNumbers(`Coder ${scope.row.coder}`, scope.row, $event)" v-html="highlightValue(scope.row.totalRecords, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'coderTrending', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'coderTrending', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'coderTrending', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Code', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'coderTrending', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'coderTrending', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'coderTrending', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'coderTrending', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-if="scope.row.poaCodes" v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`coderTrending_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'coderTrending', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`coderTrending_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'coderTrending', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <!-- <span :class="scope.row.reimbDiff < 0 ? 'negative' : ''">{{moneyFormatter(scope.row.reimbDiff)}}</span> -->
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="cdiStaffTable" v-if="grouping === '2'" key="byCdiIp" :data="isIE11 ? cdiStaffTablePagniation : cdiStaffTableData" empty-text="No CDI Staff Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="cdiStaff" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.cdiStaff" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cdiStaff" label="CDI Staff" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.cdiStaff" v-html="highlightValue(scope.row.cdiStaff, filterCriteria)" :class="`cdiStaff_cdiStaff_${scope.$index} details`" @click="buildPivotDataStats('CDI Staff Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'cdiStaff', prop: 'cdiStaff', index: scope.$index, row: scope.row }, $event, scope.row.cdiStaff)"></div>
          <div :title="scope.row.cdiStaff" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'cdiStaff', false) }}
          </div>
          <div :title="scope.row.cdiStaff" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'cdiStaff', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`CDI Staff ${scope.row.cdiStaff}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'cdiStaff', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalDRGs', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalDRGs', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'cdiStaff', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalDRGNoQuery', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalDRGNoQuery', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'cdiStaff', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'totalCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'cdiStaff', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'cmCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'cmCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'cdiStaff', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'pcsCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'pcsCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'cdiStaff', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'patStatCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'patStatCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'cdiStaff', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'pooCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'pooCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`cdiStaff_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'cdiStaff', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'poaCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'poaCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`cdiStaff_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'cdiStaff', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cdiStaff', scope.row.cdiStaff, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="drgTable" v-if="grouping === '3'" key="byDrgIp" :data="isIE11 ? drgTablePagination : drgTableData" empty-text="No DRG Data Available" stripe :summary-method="getSummaries" show-summary :height="400">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="orDrg" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.orDrg" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="orDrg" label="DRG" sortable width="55">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.orDrgDisplay, filterCriteria)" :title="scope.row.drgDescription" :class="`drg_orDrg_${scope.$index} details`" @click="buildPivotDataStats('DRG Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'drg', prop: 'orDrg', index: scope.$index, row: scope.row }, $event, scope.row.orDrgDisplay)"></div>
          <div :title="scope.row.drgDescription" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'orDrg', false) }}
          </div>
          <div :title="scope.row.drgDescription" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'orDrg', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ipReviewType" label="Type" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.ipReviewType }}</div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'ipReviewType', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'ipReviewType', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`DRG ${scope.row.orDrgDisplay}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'numClients', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'numClients', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'drg', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalDRGs', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalDRGs', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'drg', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalDRGNoQuery', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalDRGNoQuery', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'drg', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'totalCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'drg', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'cmCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'cmCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'drg', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'pcsCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'pcsCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'drg', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'patStatCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'patStatCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'drg', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'pooCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'pooCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`drg_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'drg', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'poaCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'poaCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`drg_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'drg', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('orDrg', scope.row.orDrg, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('orDrg', scope.row.orDrg, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('orDrg', scope.row.orDrg, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="patientTypeTable" v-if="grouping === '4'" key="byPatTypeIp" :data="isIE11 ? patientTypeTablePagination : patientTypeTableData" empty-text="No Patient Type Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="patTypeDesc" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.orDrg" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patTypeDesc" label="Patient Type" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.patTypeDesc" v-html="highlightValue(scope.row.patTypeDesc, filterCriteria)" :class="`patType_patTypeDesc_${scope.$index} details`" @click="buildPivotDataStats('Patient Type Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'patType', prop: 'patTypeDesc', index: scope.$index, row: scope.row }, $event, scope.row.patTypeDesc)"></div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', false) }}
          </div>
          <div :title="scope.row.patTypeDesc" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patTypeDesc', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Patient Type ${scope.row.patTypeDesc}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'numClients', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'patType', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalDRGs', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalDRGs', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'patType', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalDRGNoQuery', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalDRGNoQuery', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'patType', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'totalCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'patType', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'cmCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'patType', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pcsCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'patType', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patStatCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'patStatCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'patType', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pooCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'pooCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`patType_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'patType', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'poaCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'poaCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`patType_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'patType', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('patTypeDesc', scope.row.patTypeDesc, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="soiTable" v-if="grouping === '21'" key="bySoiIp" :data="soiTableData" empty-text="No SOI Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="origValue" label="Original SOI" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.origValue, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="noChange" label="No Change" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.noChange !== 0 ? 'details' : ''" :title="scope.row.noChange !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.noChange, filterCriteria)" @click="scope.row.noChange !== 0 && buildAccountNumbers(`Original SOI ${scope.row.origValue} - No Change`, { ...scope.row, accountNumbers: scope.row.noChangeAccounts }, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="increases" label="Increases" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.increases !== 0 ? 'details' : ''" :title="scope.row.increases !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.increases, filterCriteria)" @click="scope.row.increases !== 0 && buildAccountNumbers(`Original SOI ${scope.row.origValue} - Increases`, { ...scope.row, accountNumbers: scope.row.increasesAccounts }, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="decreases" label="Decreases" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.decreases !== 0 ? 'details' : ''" :title="scope.row.decreases !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.decreases, filterCriteria)" @click="scope.row.decreases !== 0 && buildAccountNumbers(`Original SOI ${scope.row.origValue} - Decreases`, { ...scope.row, accountNumbers: scope.row.decreasesAccounts }, $event)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="romTable" v-if="grouping === '22'" key="byRomIp" :data="romTableData" empty-text="No ROM Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="origValue" label="Original ROM" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.origValue, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="noChange" label="No Change" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.noChange !== 0 ? 'details' : ''" :title="scope.row.noChange !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.noChange, filterCriteria)" @click="scope.row.noChange !== 0 && buildAccountNumbers(`Original ROM ${scope.row.origValue} - No Change`, { ...scope.row, accountNumbers: scope.row.noChangeAccounts }, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="increases" label="Increases" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.increases !== 0 ? 'details' : ''" :title="scope.row.increases !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.increases, filterCriteria)" @click="scope.row.increases !== 0 && buildAccountNumbers(`Original ROM ${scope.row.origValue} - Increases`, { ...scope.row, accountNumbers: scope.row.increasesAccounts }, $event)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="decreases" label="Decreases" sortable>
        <template slot-scope="scope">
          <div :class="scope.row.decreases !== 0 ? 'details' : ''" :title="scope.row.decreases !== 0 ? 'View Account Numbers' : ''" v-html="highlightValue(scope.row.decreases, filterCriteria)" @click="scope.row.decreases !== 0 && buildAccountNumbers(`Original ROM ${scope.row.origValue} - Decreases`, { ...scope.row, accountNumbers: scope.row.decreasesAccounts }, $event)"></div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="reasonTable" v-if="grouping === '6'" key="byReasonIp" :data="isIE11 ? reasonTablePagination : reasonTableData" empty-text="No Reason Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="changeReason" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.orDrg" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeReason" label="Reason" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.changeReason" v-html="highlightValue(scope.row.changeReason, filterCriteria)" :class="`reason_changeReason_${scope.$index} details`" @click="buildPivotDataStats('Reason Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'reason', prop: 'changeReason', index: scope.$index, row: scope.row }, $event, scope.row.changeReason)"></div>
          <div :title="scope.row.changeReason" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'changeReason', false) }}
          </div>
          <div :title="scope.row.changeReason" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'changeReason', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="changeDesc" label="Description" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.changeDesc }}</div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'changeDesc', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'changeDesc', true) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Reason ${scope.row.changeReason}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'numClients', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'numClients', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`reason_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'reason', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('changeReason', scope.row.changeReason, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('changeReason', scope.row.changeReason, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('changeReason', scope.row.changeReason, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="facilityTable" v-if="grouping === '7'" key="byFacIp" :data="isIE11 ? facilityTablePagination : facilityTableData" empty-text="No Facility Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="cliName" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.cliName" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cliName" label="Facility" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.cliName" v-html="highlightValue(scope.row.cliName, filterCriteria)" :class="`facility_cliName_${scope.$index} details`" @click="buildPivotDataStats('Facility Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'facility', prop: 'cliName', index: scope.$index, row: scope.row }, $event, scope.row.cliName)"></div>
          <div :title="`${bedSize} bed size reviews`" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cliName', false) }}
          </div>
          <div title="All bed size reviews" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cliName', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Facility ${scope.row.cliName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'numClients', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'facility', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalDRGs', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalDRGs', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'facility', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalDRGNoQuery', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalDRGNoQuery', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'facility', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'totalCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'facility', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'cmCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'facility', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pcsCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'facility', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'patStatCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'patStatCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'facility', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pooCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'pooCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`facility_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'facility', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'poaCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'poaCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`facility_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'facility', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('cliName', scope.row.cliName, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('cliName', scope.row.cliName, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('cliName', scope.row.cliName, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="projectTable" v-if="grouping === '23'" key="byProjectIp" :data="isIE11 ? projectTablePagination : projectTableData" empty-text="No Project Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="projectName" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.projectName" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectName" label="Project" sortable>
        <template slot-scope="scope">
          <div :title="scope.row.projectName" v-html="highlightValue(scope.row.projectName, filterCriteria)" :class="`project_projectName_${scope.$index} details`" @click="buildPivotDataStats('Project Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'project', prop: 'projectName', index: scope.$index, row: scope.row }, $event, scope.row.projectName)"></div>
          <div :title="`${bedSize} bed size reviews`" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'projectName', false) }}
          </div>
          <div title="All bed size reviews" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'projectName', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="projectStartDate" label="Start Date" sortable width="120">
        <template slot-scope="scope">
          <div v-html="highlightValue(formatDate(scope.row.projectStartDate), filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Project ${scope.row.projectName}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalRecords', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalRecords', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'numClients', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'numClients', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`project_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'project', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalDRGs', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalDRGs', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`project_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'project', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalDRGNoQuery', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalDRGNoQuery', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'project', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'totalCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'project', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cmCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'cmCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'project', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'pcsCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'pcsCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'project', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'patStatCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'patStatCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'project', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'pooCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'pooCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`project_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'project', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'poaCodes', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'poaCodes', true) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`project_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'project', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('projectName', scope.row.projectName, 'reimbDiff', false).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'reimbDiff', false) }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length" :class="getBedSizeValue('projectName', scope.row.projectName, 'reimbDiff', true).includes('-') ? 'negative' : ''">
            {{ getBedSizeValue('projectName', scope.row.projectName, 'reimbDiff', true) }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="dxTable" v-if="grouping === '8'" key="byDxIp" :data="isIE11 || isCodeGrouping() ? dxTablePagination : dxTableData" empty-text="No Dx Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'dx') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`" @click="buildPivotData('Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'dx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Accuracy Rate', scope.row.numOfPoaNoRec, scope.row.numOfPoaRec, { table: 'dx', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" sortable="custom">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', false, 'dx') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', true, 'dx') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="sdohTable" v-if="grouping === '18' || grouping === '24'" :key="grouping === '24' ? 'bypriDxIp' : 'bysdohIp'" :data="isIE11 || isCodeGrouping() ? sdohTablePagination : sdohTableData" :empty-text="grouping === '24' ? 'No Pri Dx Data Available' : 'No SDOH Dx Data Available'" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'sdoh') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`${grouping === '24' ? 'Pri Dx' : 'By SDOH Dx'} Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`" @click="buildPivotData(grouping === '24' ? 'Pri Dx Accuracy Rate' : 'SDOH Dx Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, grouping === '24' ? priDxRevisionCount(scope.row) : scope.row.numOfRevisions, { table: 'dx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Accuracy Rate', scope.row.numOfPoaNoRec, scope.row.numOfPoaRec, { table: 'dx', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" sortable="custom">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', false, 'sdoh') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', true, 'sdoh') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="pxTable" v-if="grouping === '9'" key="byPxIp" :data="isIE11 || isCodeGrouping() ? pxTablePagination : pxTableData" empty-text="No PCS Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'px') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`PCS Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'px') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('px pcsCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`px_pcsCodes_${scope.$index} details`" @click="buildPivotData('PCS Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'px', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'pcsCodes', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'pcsCodes', true, 'px') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="CCTable" v-if="grouping === '10'" key="byCCIp" :data="isIE11 || isCodeGrouping() ? ccTablePagination : ccTableData" empty-text="No CC Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'cc') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`" @click="buildPivotData('CC Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'dx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Accuracy Rate', scope.row.numOfPoaNoRec, scope.row.numOfPoaRec, { table: 'dx', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" sortable="custom">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', false, 'cc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', true, 'cc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="MCCTable" v-if="grouping === '11'" key="byMccIp" :data="isIE11 || isCodeGrouping() ? mccTablePagination : mccTableData" empty-text="No MCC Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'mcc') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`" @click="buildPivotData('MCC Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'dx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Accuracy Rate', scope.row.numOfPoaNoRec, scope.row.numOfPoaRec, { table: 'dx', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" sortable="custom">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', false, 'mcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', true, 'mcc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="HACTable" v-if="grouping === '12'" key="byHacIp" :data="isIE11 || isCodeGrouping() ? hacTablePagination : hacTableData" empty-text="No HAC Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="Code" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'hac') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_cmCodes_${scope.$index} details`" @click="buildPivotData('HAC Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'dx', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'cmCodes', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx poaCodes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`dx_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Accuracy Rate', scope.row.numOfPoaNoRec, scope.row.numOfPoaRec, { table: 'dx', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'poaCodes', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isAHacCode" label="Potential HAC" sortable="custom">
        <template slot-scope="scope">
          <div><i v-if="scope.row.isAHacCode" class="mdi mdi-check-bold" style="color: rgb(124, 190, 95); font-size: 18px;"></i></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', false, 'hac') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'isAHacCode', true, 'hac') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="HCCTable" v-if="grouping === '13'" key="byHccIp" :data="isIE11 || isCodeGrouping() ? hccTablePagination : hccTableData" empty-text="No HCC V24 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV24')"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'hcc') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'hcc') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`hcc_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V24 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'hcc', prop: 'hccV24AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', false, 'hcc') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', true, 'hcc') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="HCCV28Table" v-if="grouping === '17'" key="byHccV28Ip" :data="isIE11 || isCodeGrouping() ? hccV28TablePagination : hccV28TableData" empty-text="No HCC V28 Data Available" :height="400" stripe :summary-method="getSummaries" show-summary row-key="code" @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="code" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.code" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="HCC" sortable="custom">
        <template slot-scope="scope">
          <div class="details" v-html="highlightValue(scope.row.code, filterCriteria)" @click="buildDxPopover(`${scope.row.description}`, scope.row, $event, 'HCCV28')"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', false, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'code', true, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.description" v-html="highlightValue(scope.row.description, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', false, 'hccv28') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'description', true, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`Dx Code ${scope.row.code}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', false, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'totalRecords', true, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients, filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="accuracyRate" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('dx cmCodes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracyRate * 100).toFixed(2)}%`, filterCriteria)" :class="`hccv28_accuracyRate_${scope.$index} details`" @click="buildPivotData('HCC V28 Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, scope.row.numOfRevisions, { table: 'hccv28', prop: 'hccV28AccuracyRate', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracyRate * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', false, 'hccv28') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'accuracyRate', true, 'hccv28') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="psiTable" v-if="grouping === '14'" key="byPsiIp" :data="isIE11 || isCodeGrouping() ? psiTablePagination : psiTableData" empty-text="No PSI Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="shortDescription" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.shortDescription" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shortDescription" label="Indicator" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.shortDescription, filterCriteria)" @click="openUrl(scope.row.href)" class="openUrl"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="longDescription" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.longDescription" v-html="highlightValue(scope.row.longDescription, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', false, 'psi') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`PSI ${scope.row.shortDescription}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfNoRec" label="No Recommendations" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfNoRec, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`PSI ${scope.row.shortDescription}`, scope.row, 'noRecAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfAdditions" label="Additions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfAdditions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`PSI ${scope.row.shortDescription}`, scope.row, 'additionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfDeletions" label="Deletions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfDeletions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`PSI ${scope.row.shortDescription}`, scope.row, 'deletionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients ,filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'px') }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="accuracy" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('qmpsi accuracy', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracy * 100).toFixed(2)}%`, filterCriteria)" :class="`psi_accuracy_${scope.$index} details`" @click="buildPivotData('PSI Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, 0, { table: 'psi', prop: 'accuracy', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracy * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="qmMortalityTable" v-if="grouping === '15'" key="byQMMIp" :data="isIE11 || isCodeGrouping() ? qmMortalityTablePagination : qmMortalityTableData" empty-text="No QM Mortality Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="shortDescription" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.shortDescription" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shortDescription" label="Measure" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.shortDescription, filterCriteria)" @click="openUrl('https://www.qualitynet.org/inpatient/measures/mortality/methodology')" class="openUrl"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', false, 'qmMortality') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', true, 'qmMortality') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="longDescription" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.longDescription" v-html="highlightValue(scope.row.longDescription, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', false, 'qmMortality') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', true, 'qmMortality') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`QM Mortality ${scope.row.shortDescription}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', false, 'qmMortality') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', true, 'qmMortality') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfNoRec" label="No Recommendations" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfNoRec, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'noRecAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfAdditions" label="Additions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfAdditions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'additionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfDeletions" label="Deletions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfDeletions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'deletionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients ,filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'px') }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="accuracy" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('qmpsi accuracy', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracy * 100).toFixed(2)}%`, filterCriteria)" :class="`qmMortality_accuracy_${scope.$index} details`" @click="buildPivotData('QM Mortality Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, 0, { table: 'qmMortality', prop: 'accuracy', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracy * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', false, 'qmMortality') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', true, 'qmMortality') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table class="tableNoWrap" ref="qmReadmissionTable" v-if="grouping === '16'" key="byQMRIp" :data="isIE11 || isCodeGrouping() ? qmReadmissionTablePagination : qmReadmissionTableData" empty-text="No QM Readmission Data Available" :height="400" stripe :summary-method="getSummaries" show-summary @sort-change="handleSortChange">
      <el-table-column v-if="activateComparison && comparisonAccounts.length" prop="shortDescription" label=" " width="25">
        <template slot-scope="scope">
          <div>
            <i :title="`${currentClient} reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: rgba(19, 86, 149, .8);" :tag="scope.row.shortDescription" class="mdi mdi-set-center"></i>
          </div>
          <div>
            <i :title="`${bedSize} bed size reviews`" style="float: left; font-size: 23px; margin: -1px 0px 0px -7px; color: #67C23A;" class="mdi mdi-set-center-right"></i>
          </div>
          <div>
            <i title="All bed size reviews" style="float: left; font-size: 23px; margin: -2px 0px 0px -7px; color: rgba(236, 0, 140, 0.8);" class="mdi mdi-set-all"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shortDescription" label="Measure" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.shortDescription, filterCriteria)" @click="openUrl('https://www.qualitynet.org/inpatient/measures/readmission/methodology')" class="openUrl"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', false, 'qmReadmission') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'shortDescription', true, 'qmReadmission') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="longDescription" label="Description" sortable="custom">
        <template slot-scope="scope">
          <div tag="description" :title="scope.row.longDescription" v-html="highlightValue(scope.row.longDescription, filterCriteria)"></div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', false, 'qmReadmission') }}
          </div>
          <div tag="description" v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'longDescription', true, 'qmReadmission') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)" title="View Account Numbers" class="details" @click="buildAccountNumbers(`QM Readmission ${scope.row.shortDescription}`, scope.row, $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', false, 'qmReadmission') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'totalRecords', true, 'qmReadmission') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfNoRec" label="No Recommendations" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfNoRec, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'noRecAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfNoRec', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfAdditions" label="Additions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfAdditions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'additionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfAdditions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="numOfDeletions" label="Deletions" sortable="custom">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numOfDeletions, filterCriteria)" title="View Account Numbers" class="details" @click="buildPsiQmAccountNumbers(`QM ${scope.row.shortDescription}`, scope.row, 'deletionsAccounts', $event)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', false, 'psi') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'numOfDeletions', true, 'psi') }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="activateComparison" prop="numClients" label="# Clients">
        <template slot-scope="scope">
          <div v-html="highlightValue(scope.row.numClients ,filterCriteria)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', false, 'px') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('code', scope.row.code, 'numClients', true, 'px') }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="accuracy" label="Accuracy Rate" sortable="custom">
        <template slot-scope="scope">
          <div v-if="checkPercentValues('qmpsi accuracy', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.accuracy * 100).toFixed(2)}%`, filterCriteria)" :class="`qmReadmission_accuracy_${scope.$index} details`" @click="buildPivotData('QM Readmission Accuracy Rate', scope.row.numOfNoRec, scope.row.numOfAdditions, scope.row.numOfDeletions, 0, { table: 'qmReadmission', prop: 'accuracy', index: scope.$index, row: scope.row }, $event, `${(scope.row.accuracy * 100).toFixed(2)}%`)"></div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', false, 'qmReadmission') }}
          </div>
          <div v-if="activateComparison && comparisonAccounts.length">
            {{ getBedSizeValue('shortDescription', scope.row.shortDescription, 'accuracy', true, 'qmReadmission') }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-table ref="serviceLineTable" v-if="grouping === '20'" key="byServiceLineIp" :data="isIE11 ? serviceLineTablePagination : serviceLineTableData" empty-text="No Service Line Data Available" :height="400" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="clientServiceLineName" label="Service Line" sortable>
        <template slot-scope="scope">
          <div :class="`serviceLine_clientServiceLineName_${scope.$index} details`" @click="buildPivotDataStats('Service Line Stats', scope.row.totalRecords, scope.row.reimbInc, scope.row.reimbDec, scope.row.recordsWithRecommendations, { table: 'serviceLine', prop: 'clientServiceLineName', index: scope.$index, row: scope.row }, $event, scope.row.clientServiceLineName)" v-html="highlightValue(scope.row.clientServiceLineName, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Instances" sortable>
        <template slot-scope="scope">
          <div title="View Account Numbers" class="details" @click="buildAccountNumbers(`Service Line ${scope.row.clientServiceLineName}`, scope.row, $event)" v-html="highlightValue(scope.row.totalRecords, filterCriteria)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGs" label="Total DRGs" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGs * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_totalDRGs_${scope.$index} details`" @click="buildPivotData('Total DRGs', scope.row.totalRecords - scope.row.drgChanges, 0, 0, scope.row.drgChanges, { table: 'serviceLine', prop: 'totalDRGs', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGs * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalDRGNoQuery" label="Total DRGs w/o Query" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total DRGs w/o Query', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_totalDRGNoQuery_${scope.$index} details`" @click="buildPivotData('Total DRGs w/o Query', scope.row.totalRecords - scope.row.asIsDRGChanges, 0, 0, scope.row.asIsDRGChanges, { table: 'serviceLine', prop: 'totalDRGNoQuery', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalDRGNoQuery * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="totalCodes" label="Total Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Total Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.totalCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_totalCodes_${scope.$index} details`" @click="buildPivotData('Total Codes', scope.row.dxNoRec + scope.row.pxNoRec, scope.row.dxAdditions + scope.row.pxAdditions, scope.row.dxDeletions + scope.row.pxDeletions, scope.row.dxRevisions + scope.row.pxRevisions, { table: 'serviceLine', prop: 'ipTotalCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.totalCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="cmCodes" label="ICD-10 CM Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 CM Code', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.cmCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_cmCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 CM Codes', scope.row.dxNoRec, scope.row.dxAdditions, scope.row.dxDeletions, scope.row.dxRevisions, { table: 'serviceLine', prop: 'cmCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.cmCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pcsCodes" label="ICD-10 PCS Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('ICD-10 PCS Codes', scope)">
            N/A
          </div>
          <div v-else v-html="highlightValue(`${(scope.row.pcsCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_pcsCodes_${scope.$index} details`" @click="buildPivotData('ICD-10 PCS Codes', scope.row.pxNoRec, scope.row.pxAdditions, scope.row.pxDeletions, scope.row.pxRevisions, { table: 'serviceLine', prop: 'pcsCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pcsCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="patStatCodes" label="Patient Status Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Patient Status Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.patStatCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_patStatCodes_${scope.$index} details`" @click="buildPivotDataBinary('Patient Status Codes', scope.row.patStat - scope.row.patStatChanges, scope.row.patStatChanges, { table: 'serviceLine', prop: 'patStatCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.patStatCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="pooCodes" label="Point of Origin Codes" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('Point of Origin Codes', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-else v-html="highlightValue(`${(scope.row.pooCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_pooCodes_${scope.$index} details`" @click="buildPivotDataBinary('Point of Origin Codes', scope.row.poo - scope.row.pooChanges, scope.row.pooChanges, { table: 'serviceLine', prop: 'pooCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.pooCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="poaCodes" label="POA Indicators" sortable>
        <template slot-scope="scope">
          <div v-if="checkPercentValues('POA Indicators', scope)" v-html="highlightValue('N/A', filterCriteria)"></div>
          <div v-if="scope.row.poaCodes" v-html="highlightValue(`${(scope.row.poaCodes * 100).toFixed(2)}%`, filterCriteria)" :class="`serviceLine_poaCodes_${scope.$index} details`" @click="buildPivotDataBinary('POA Indicators', scope.row.poaNoRecommendations, scope.row.poaRecommendations, { table: 'serviceLine', prop: 'poaCodes', index: scope.$index, row: scope.row }, $event, `${(scope.row.poaCodes * 100).toFixed(2)}%`)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="reimbDiff" label="Reimbursement Diff" sortable>
        <template slot-scope="scope">
          <div v-html="highlightValue(moneyFormatter(scope.row.reimbDiff), filterCriteria)" :class="`serviceLine_reimbDiff_${scope.$index} details ${scope.row.reimbDiff < 0 ? 'negative' : ''}`" @click="buildPivotDataFinancials('Financial Stats', scope.row.reimbDiff, scope.row.reimbInc, scope.row.reimbDec, scope.row.reimbIncRecords, scope.row.reimbDecRecords, { table: 'serviceLine', prop: 'reimbDiff', index: scope.$index, row: scope.row }, $event, moneyFormatter(scope.row.reimbDiff))"></div>
          <!-- <span :class="scope.row.reimbDiff < 0 ? 'negative' : ''">{{moneyFormatter(scope.row.reimbDiff)}}</span> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="qmDisclaimer priDxDisclaimer" v-if="isPriDxGrouping()">Pri Dx revisions include both 'Revised From' and 'Revised To'. A single record can appear under two principal diagnoses, so the total instances can be higher than the number of unique records.</div>
    <div class="qmDisclaimer" v-if="grouping === '15' || grouping === '16'">The above analysis represents potential CMS Mortality and Readmission Quality Measure triggers. Actual readmission and mortality data is not able to be calculated based on limited data.</div>
    <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="paginationTotal" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-pagination class="pager" v-if="isCodeGrouping()" background :pager-count="15" layout="total, prev, pager, next" :page-size="codeItemsPerPage" :total="paginationTotal" :current-page.sync="currentPage" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>

    <el-popover ref="ipDetailsPopOver" :visible-arrow="false" placement="bottom" width="400" trigger="click" @after-enter="handleHidePopOver">
      <DetailsPopOver :header="header" :popOverData="popOverData" :tableType="tableType" :reviewType="reviewType" :row="row" :rowMeta="rowMeta" :isOpen="isOpen" @tableTypeChange="handleTableTypeChange" @headerChange="header = $event"> </DetailsPopOver>
    </el-popover>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import hiaFilters from '@/mixins/hiaFilters'
import DetailsPopOver from '@/views/Dashboards/DetailsPopOver'
import { shouldDismissDashboardPopover, patchPopoverDocumentClick } from '@/utilities/dashboardPopoverDismiss'
import { mapState, mapActions, mapMutations } from 'vuex'
import { format, parseISO } from 'date-fns'

export default {
  data: function() {
    return {
      header: '',
      popOverData: [],
      popperClickTarget: undefined,
      tableType: '',
      reviewType: 'ip',
      row: {},
      rowMeta: {},
      isOpen: false,
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true,
      codeItemsPerPage: 60,
      sortProp: '',
      sortOrder: ''
    }
  },
  name: 'InpatientTables',
  mixins: [HiaAuthorization, money, hiaFilters],
  props: {
    grouping: { type: String },
    filterCriteria: { type: String },
    selectedGrouping: { type: Array },
    activateComparison: { type: Boolean },
    bedSize: { type: String }
  },
  components: {
    DetailsPopOver
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_PROJECTS']),
    ...mapMutations('dashboard/', ['CLEAR_DASHBOARD_ACCOUNTS']),
    moneyFormatter(value) {
      return `$${this.formatMoney(value)}`
    },
    getSummaryData() {
      let data = this.isIE11 ? this.paginationSummaries : []
      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }
      if (!data || !data.length) {
        switch (this.grouping) {
          case '1':
            data = this.coderTableData
            break
          case '19':
            data = this.coderTrendingTableData
            break
          case '2':
            data = this.cdiStaffTableData
            break
          case '3':
            data = this.drgTableData
            break
          case '4':
            data = this.patientTypeTableData
            break
          case '6':
            data = this.reasonTableData
            break
          case '7':
            data = this.facilityTableData
            break
          case '23':
            data = this.projectTableData
            break
          case '8':
            data = this.dxTableData
            break
          case '18':
            data = this.sdohTableData
            break
          case '24':
            data = this.sdohTableData
            break
          case '9':
            data = this.pxTableData
            break
          case '10':
            data = this.ccTableData
            break
          case '11':
            data = this.mccTableData
            break
          case '12':
            data = this.hacTableData
            break
          case '13':
            data = this.hccTableData
            break
          case '17':
            data = this.hccV28TableData
            break
          case '14':
            data = this.psiTableData
            break
          case '15':
            data = this.qmMortalityTableData
            break
          case '16':
            data = this.qmReadmissionTableData
            break
          case '20':
            data = this.serviceLineTableData
            break
          case '21':
            data = this.soiTableData
            break
          case '22':
            data = this.romTableData
            break
        }
      }
      return data || []
    },
    isPriDxGrouping() {
      return this.grouping === '24'
    },
    priDxRevisionCount(row) {
      const fromVal = row.numOfRevisedFrom != null ? row.numOfRevisedFrom : row.revisedFromCount
      const toVal = row.numOfRevisedTo != null ? row.numOfRevisedTo : row.revisedToCount
      const from = Number(fromVal)
      const to = Number(toVal)
      return (isNaN(from) ? 0 : from) + (isNaN(to) ? 0 : to)
    },
    buildSummaryPivotData(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const sum = field => data.reduce((t, r) => t + (isNaN(Number(r[field])) ? 0 : r[field]), 0)
      let allAccountNumbers = data
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      const fakeRow = { table: 'summary', prop: columnProperty, row: { accountNumbers: allAccountNumbers } }

      switch (columnProperty) {
        case 'totalDRGs': {
          let noRecs = sum('totalRecords') - sum('drgChanges')
          let revs = sum('drgChanges')
          let displayValue = this.calculatePercentages(noRecs + revs, revs)
          this.buildPivotData('Total DRGs', noRecs, 0, 0, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'totalDRGNoQuery': {
          let noRecs = sum('totalRecords') - sum('asIsDRGChanges')
          let revs = sum('asIsDRGChanges')
          let displayValue = this.calculatePercentages(noRecs + revs, revs)
          this.buildPivotData('Total DRGs w/o Query', noRecs, 0, 0, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'totalCodes': {
          let noRecs = sum('dxNoRec') + sum('pxNoRec')
          let adds = sum('dxAdditions') + sum('pxAdditions')
          let dels = sum('dxDeletions') + sum('pxDeletions')
          let revs = sum('dxRevisions') + sum('pxRevisions')
          let tcRow = { table: 'summary', prop: 'ipTotalCodes', row: { accountNumbers: allAccountNumbers } }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          this.buildPivotData('Total Codes', noRecs, adds, dels, revs, tcRow, { target: targetElement }, displayValue)
          break
        }
        case 'cmCodes': {
          if (this.grouping === '8' || this.grouping === '18' || this.grouping === '24' || this.grouping === '10' || this.grouping === '11' || this.grouping === '12') {
            let noRecs = sum('numOfNoRec')
            let adds = sum('numOfAdditions')
            let dels = sum('numOfDeletions')
            let revs = this.isPriDxGrouping()
              ? data.reduce((t, r) => t + this.priDxRevisionCount(r), 0)
              : sum('numOfRevisions')
            let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
            let title = 'Dx Accuracy Rate'
            if (this.grouping === '24') title = 'Pri Dx Accuracy Rate'
            if (this.grouping === '18') title = 'SDOH Dx Accuracy Rate'
            else if (this.grouping === '10') title = 'CC Accuracy Rate'
            else if (this.grouping === '11') title = 'MCC Accuracy Rate'
            else if (this.grouping === '12') title = 'HAC Accuracy Rate'
            this.buildPivotData(title, noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          } else {
            let noRecs = sum('dxNoRec')
            let adds = sum('dxAdditions')
            let dels = sum('dxDeletions')
            let revs = sum('dxRevisions')
            let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
            this.buildPivotData('ICD-10 CM Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          }
          break
        }
        case 'pcsCodes': {
          if (this.grouping === '9') {
            let noRecs = sum('numOfNoRec')
            let adds = sum('numOfAdditions')
            let dels = sum('numOfDeletions')
            let revs = sum('numOfRevisions')
            let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
            this.buildPivotData('PCS Accuracy Rate', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          } else {
            let noRecs = sum('pxNoRec')
            let adds = sum('pxAdditions')
            let dels = sum('pxDeletions')
            let revs = sum('pxRevisions')
            let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
            this.buildPivotData('ICD-10 PCS Codes', noRecs, adds, dels, revs, fakeRow, { target: targetElement }, displayValue)
          }
          break
        }
        case 'patStatCodes': {
          let noRecs = sum('patStat') - sum('patStatChanges')
          let revs = sum('patStatChanges')
          let displayValue = this.calculatePercentages(noRecs + revs, revs)
          this.buildPivotDataBinary('Patient Status Codes', noRecs, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'pooCodes': {
          let noRecs = sum('poo') - sum('pooChanges')
          let revs = sum('pooChanges')
          let displayValue = this.calculatePercentages(noRecs + revs, revs)
          this.buildPivotDataBinary('Point of Origin Codes', noRecs, revs, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'poaCodes': {
          if (this.grouping === '8' || this.grouping === '18' || this.grouping === '24' || this.grouping === '10' || this.grouping === '11' || this.grouping === '12') {
            let noRecs = sum('numOfPoaNoRec')
            let revs = sum('numOfPoaRec')
            let displayValue = this.calculatePercentages(noRecs + revs, revs)
            this.buildPivotDataBinary('POA Accuracy Rate', noRecs, revs, fakeRow, { target: targetElement }, displayValue)
          } else {
            let noRecs = sum('poaNoRecommendations')
            let revs = sum('poaRecommendations')
            let displayValue = this.calculatePercentages(noRecs + revs, revs)
            this.buildPivotDataBinary('POA Indicators', noRecs, revs, fakeRow, { target: targetElement }, displayValue)
          }
          break
        }
        case 'reimbDiff': {
          let reimbDiff = sum('reimbDiff')
          let reimbInc = sum('reimbInc')
          let reimbDec = sum('reimbDec')
          let reimbIncRecords = sum('reimbIncRecords')
          let reimbDecRecords = sum('reimbDecRecords')
          let displayValue = this.moneyFormatter(reimbDiff)
          this.buildPivotDataFinancials('Financial Stats', reimbDiff, reimbInc, reimbDec, reimbIncRecords, reimbDecRecords, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'accuracy': {
          let noRecs = sum('numOfNoRec')
          let adds = sum('numOfAdditions')
          let dels = sum('numOfDeletions')
          let revs = sum('numOfRevisions')
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          let title = 'PSI Accuracy Rate'
          if (this.grouping === '15') title = 'QM Mortality Accuracy Rate'
          else if (this.grouping === '16') title = 'QM Readmission Accuracy Rate'
          this.buildPivotData(title, noRecs, adds, dels, 0, fakeRow, { target: targetElement }, displayValue)
          break
        }
        case 'accuracyRate': {
          let noRecs = sum('numOfNoRec')
          let adds = sum('numOfAdditions')
          let dels = sum('numOfDeletions')
          let revs = sum('numOfRevisions')
          let dimension = this.grouping === '17' ? 'hccV28AccuracyRate' : 'hccV24AccuracyRate'
          let hccFakeRow = { table: 'summary', prop: dimension, row: { accountNumbers: allAccountNumbers } }
          let displayValue = this.calculatePercentages(noRecs + adds + dels + revs, adds + dels + revs)
          let title = this.grouping === '17' ? 'HCC V28 Accuracy Rate' : 'HCC V24 Accuracy Rate'
          this.buildPivotData(title, noRecs, adds, dels, revs, hccFakeRow, { target: targetElement }, displayValue)
          break
        }
      }
    },
    buildSummaryAccountNumbers(targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return
      let allAccountNumbers = data
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      if (!allAccountNumbers) return
      let syntheticRow = { accountNumbers: allAccountNumbers }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = 'Total Instances'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    buildSummaryHacAccountNumbers(targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return
      let hacAccountNumbers = data
        .filter(r => r.isAHacCode)
        .map(r => r.accountNumbers)
        .filter(a => a)
        .join(',')
      if (!hacAccountNumbers) return
      let syntheticRow = { accountNumbers: hacAccountNumbers }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = 'Potential HAC Instances'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    buildSummaryPsiQmAccountNumbers(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const accountFieldMap = {
        numOfNoRec: 'noRecAccounts',
        numOfAdditions: 'additionsAccounts',
        numOfDeletions: 'deletionsAccounts'
      }
      let accountField = accountFieldMap[columnProperty]
      if (!accountField) return

      let allAccounts = data
        .map(r => r[accountField])
        .filter(a => a)
        .join(',')
      if (!allAccounts) return

      let syntheticRow = { [accountField]: allAccounts }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = accountField
        this.header = columnProperty === 'numOfNoRec' ? 'No Recommendations' : columnProperty === 'numOfAdditions' ? 'Additions' : 'Deletions'
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    buildSummarySoiRomAccountNumbers(columnProperty, targetElement) {
      let data = this.getSummaryData()
      if (!data.length) return

      const accountFieldMap = {
        noChange: 'noChangeAccounts',
        increases: 'increasesAccounts',
        decreases: 'decreasesAccounts'
      }
      let accountField = accountFieldMap[columnProperty]
      if (!accountField) return

      let allAccounts = data
        .map(r => r[accountField])
        .filter(a => a)
        .join(',')
      if (!allAccounts) return

      let label = this.grouping === '21' ? 'SOI' : 'ROM'
      let colLabel = columnProperty === 'noChange' ? 'No Change' : columnProperty === 'increases' ? 'Increases' : 'Decreases'
      let syntheticRow = { accountNumbers: allAccounts }
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = `${label} - ${colLabel}`
        this.popOverData = []
        this.row = syntheticRow
        this.handleShowDetailsPopover(targetElement)
      })
    },
    getActiveTableRef() {
      const map = {
        '1': 'coderTable',
        '19': 'coderTrendingTable',
        '2': 'cdiStaffTable',
        '3': 'drgTable',
        '4': 'patientTypeTable',
        '6': 'reasonTable',
        '7': 'facilityTable',
        '23': 'projectTable',
        '8': 'dxTable',
        '18': 'sdohTable',
        '24': 'sdohTable',
        '9': 'pxTable',
        '10': 'CCTable',
        '11': 'MCCTable',
        '12': 'HACTable',
        '13': 'HCCTable',
        '17': 'HCCV28Table',
        '14': 'psiTable',
        '15': 'qmMortalityTable',
        '16': 'qmReadmissionTable',
        '20': 'serviceLineTable',
        '21': 'soiTable',
        '22': 'romTable'
      }
      return map[this.grouping] || null
    },
    attachSummaryClickHandlers() {
      this.cleanupSummaryHandlers()

      let tableRef = this.getActiveTableRef()
      if (!tableRef || !this.$refs[tableRef]) return

      let tableEl = this.$refs[tableRef].$el
      let footerWrapper = tableEl.querySelector('.el-table__footer-wrapper')
      if (!footerWrapper) return

      let footerCells = footerWrapper.querySelectorAll('td')
      let table = this.$refs[tableRef]
      let columns = table.columns || []

      const clickableColumns = ['totalRecords', 'totalDRGs', 'totalDRGNoQuery', 'totalCodes', 'cmCodes', 'pcsCodes', 'patStatCodes', 'pooCodes', 'poaCodes', 'reimbDiff', 'accuracy', 'accuracyRate', 'numOfNoRec', 'numOfAdditions', 'numOfDeletions', 'noChange', 'increases', 'decreases', 'isAHacCode']

      footerCells.forEach((td, index) => {
        if (index >= columns.length) return
        let colProp = columns[index].property
        if (clickableColumns.includes(colProp)) {
          let cellText = td.textContent.trim()
          if (!cellText || cellText === 'N/A' || cellText === '' || cellText === '—') return

          td.classList.add('details')
          let handler = e => {
            e.stopPropagation()
            if (colProp === 'totalRecords') {
              this.buildSummaryAccountNumbers(td)
            } else if (colProp === 'isAHacCode') {
              this.buildSummaryHacAccountNumbers(td)
            } else if (['numOfNoRec', 'numOfAdditions', 'numOfDeletions'].includes(colProp)) {
              this.buildSummaryPsiQmAccountNumbers(colProp, td)
            } else if (['noChange', 'increases', 'decreases'].includes(colProp)) {
              this.buildSummarySoiRomAccountNumbers(colProp, td)
            } else {
              this.buildSummaryPivotData(colProp, td)
            }
          }
          td.addEventListener('click', handler)
          this._summaryHandlers.push({ el: td, handler: handler })
        }
      })
    },
    cleanupSummaryHandlers() {
      if (this._summaryHandlers) {
        this._summaryHandlers.forEach(({ el, handler }) => {
          el.removeEventListener('click', handler)
          el.classList.remove('details')
        })
      }
      this._summaryHandlers = []
    },
    getTableData(grouping) {
      let data = []
      let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
      if (ipIndex !== null && this.reviewDashboardData[ipIndex].largeStats) {
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        if (this.filterCriteria.length) {
          data = this.filterList(data, this.filterCriteria)
        }

        if (this.selectedGrouping.length) {
          let groupKey = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].groupKey : ''
          data = data.filter(x => {
            let val
            this.selectedGrouping.forEach(y => {
              if (x[groupKey].toString() === y.toString()) {
                val = x
              }
            })
            return val
          })
        }

        return data
      }
      return []
    },
    buildDxPopover(title, row, e, hccVersion) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'dxDashboard'
        this.header = `HCC ${title}`
        this.popOverData = []
        this.row = row
        this.row.hccVersion = hccVersion
        this.handleShowDetailsPopover(e.target)
      })
    },
    handleTableTypeChange(newType) {
      this.tableType = newType
      if (newType === 'accountNumbers') {
        this.$nextTick(() => {
          this.$refs.ipDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      }
    },
    buildPivotData(header, noRecs, adds, dels, revs, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'stats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Total Reviewed', value: noRecs + adds + dels + revs }, { title: 'Total Recommendations', value: adds + dels + revs }, { title: '', value: '' }, { title: 'No Recommendations', value: noRecs }, { title: 'Additions', value: adds }, { title: 'Deletions', value: dels }]
        // include revisions line for all except HCC
        if (!(row.table && (row.table === 'hcc' || row.table === 'hccv28'))) {
          this.popOverData.push({ title: 'Revisions', value: revs })
        }
        this.rowMeta = {
          table: row.table,
          prop: row.prop
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataBinary(header, noRecs, revs, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'binary'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'No Recommendations', value: noRecs }, { title: 'Revisions', value: revs }]

        this.rowMeta = {
          table: row.table,
          prop: row.prop
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataStats(header, totalRecords, reimbInc, reimbDec, recordsWithRecommendations, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'dataStats'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Number of Records', value: totalRecords }, { title: 'Record Recommendations', value: recordsWithRecommendations }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }]
        this.rowMeta = {
          table: row.table,
          prop: 'mainDashboardGrouping'
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildPivotDataFinancials(header, reimbDiff, reimbInc, reimbDec, reimbIncRecords, reimbDecRecords, row, e, displayValue) {
      this.$nextTick(() => {
        this.tableType = 'financial'
        this.header = displayValue ? `${header} - ${displayValue}` : header
        this.popOverData = [{ title: 'Reimbursement Diff', value: reimbDiff }, { title: 'Reimbursement Decrease', value: reimbDec }, { title: 'Reimbursement Increase', value: reimbInc }, { title: 'Reimbursement Decrease Records', value: reimbDecRecords }, { title: 'Reimbursement Increase Records', value: reimbIncRecords }]
        this.rowMeta = {
          table: row.table,
          prop: row.prop
        }
        this.row = row.row
        this.handleShowPopOver(row, e ? e.target : undefined)
      })
    },
    buildAccountNumbers(title, row, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = title
        this.popOverData = []
        this.row = row
        this.handleShowDetailsPopover(e.target)
      })
    },
    buildPsiQmAccountNumbers(title, row, type, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = type
        this.header = title
        this.popOverData = []
        this.row = row
        this.handleShowDetailsPopover(e.target)
      })
    },
    handleShowDetailsPopover(clickTarget) {
      let popper = this.$refs.ipDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = clickTarget
        let popperRef = document.querySelector('#reviewDashboard')
        popper.doDestroy()
        popper.referenceElm = popperRef
        this.isOpen = true
        popper.$refs.popper.classList.add('largeCenterPopOver')
        popper.doShow()
        this.$nextTick(() => {
          this.$refs.ipDetailsPopOver.$refs.popper.classList.add('largeCenterPopOver')
        })
      })
    },
    handleShowPopOver(row, targetElement) {
      let popper = this.$refs.ipDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = targetElement || document.querySelector(`.${row.table}_${row.prop}_${row.index}`)
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    },
    handleHidePopOver() {
      let popper = this.$refs.ipDetailsPopOver
      patchPopoverDocumentClick(popper)
      const handler = e => {
        if (shouldDismissDashboardPopover(e, popper, this.popperClickTarget)) {
          this.CLEAR_DASHBOARD_ACCOUNTS()
          this.isOpen = false
          popper.doClose()
          popper.doDestroy()
          this.clearClass()
          document.removeEventListener('click', handler, false)
        }
      }
      document.addEventListener('click', handler, false)
    },
    clearPopOverData() {
      this.CLEAR_DASHBOARD_ACCOUNTS()
      this.tableType = ''
      this.header = ''
      this.popOverData = []
      this.row = {}
      this.isOpen = false
    },
    clearClass() {
      let popper = this.$refs.ipDetailsPopOver
      popper.$refs.popper.classList.remove('largeCenterPopOver')
    },
    getSummaries(param) {
      let { columns, data } = param
      const sums = []

      if (this.isIE11) {
        data = this.paginationSummaries
      }

      if (this.isCodeGrouping()) {
        data = this.codeGroupingAllData
      }

      columns.forEach((column, index) => {
        switch (column.property) {
          case 'coder':
          case 'cdiStaff':
          case 'orDrg':
          case 'patTypeDesc':
          case 'changeReason':
          case 'cliName':
          case 'projectName':
          case 'projectStartDate':
          case 'changeDesc':
          case 'ipReviewType':
          case 'code':
          case 'description':
          case 'hcc':
          case 'clientServiceLineName':
          case 'origValue':
          case 'shortDescription':
          case 'longDescription':
            if (index === 0 || (this.activateComparison && this.comparisonAccounts.length && index === 1)) {
              sums[index] = 'Total'
            } else {
              sums[index] = ''
            }
            break
          case 'totalRecords':
          case 'increases':
          case 'decreases':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'totalDRGs':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'totalDRGNoQuery':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'totalCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'cmCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'pcsCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'patStatCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'pooCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'poaCodes':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          case 'reimbDiff':
            let value = this.totalMoneySummary(column.property, data, index)
            let td = document.querySelector(`.el-table__footer .${column.id}`)

            if (td) {
              if (value.replace(/[$]|[,]/g, '') < 0) {
                td.classList.add('negative_td')
              } else {
                td.classList.remove('negative_td')
              }
            }

            sums[index] = value
            break
          case 'isAHacCode':
            sums[index] = this.totalHACSummary(column.property, data, index)
            break
          case 'noChange':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'numOfNoRec':
          case 'numOfAdditions':
          case 'numOfDeletions':
            sums[index] = this.totalSummary(column.property, data, index)
            break
          case 'accuracy':
          case 'accuracyRate':
            sums[index] = this.totalPercentSummaries(column.property, data, index, column)
            break
          default:
            sums[index] = 'N/A'
        }
      })

      return sums
    },
    totalPercentSummaries(column, data, index, columnArray) {
      let mt = 0
      let adr = 0
      for (let i = 0; i < data.length; i++) {
        // totalDRGs Summary
        if (column === 'totalDRGs') {
          if (!isNaN(Number(data[i]['totalRecords']))) {
            mt += data[i]['totalRecords']
          }

          if (!isNaN(Number(data[i]['drgChanges']))) {
            adr += data[i]['drgChanges']
          }
        }

        // totalDRGNoQuery Summary
        if (column === 'totalDRGNoQuery') {
          if (!isNaN(Number(data[i]['totalRecords']))) {
            mt += data[i]['totalRecords']
          }

          if (!isNaN(Number(data[i]['asIsDRGChanges']))) {
            adr += data[i]['asIsDRGChanges']
          }
        }

        // totalCodes Summary
        if (column === 'totalCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }
        }

        // cmCodes Summary
        if (column === 'cmCodes') {
          if (!isNaN(Number(data[i]['dxNoRec'])) || !isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            mt += data[i]['dxNoRec'] + data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }

          if (!isNaN(Number(data[i]['dxAdditions'])) || !isNaN(Number(data[i]['dxDeletions'])) || !isNaN(Number(data[i]['dxRevisions']))) {
            adr += data[i]['dxAdditions'] + data[i]['dxDeletions'] + data[i]['dxRevisions']
          }
        }

        // pcsCodes Summary
        if (column === 'pcsCodes') {
          if (!isNaN(Number(data[i]['pxNoRec'])) || !isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            mt += data[i]['pxNoRec'] + data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }

          if (!isNaN(Number(data[i]['pxAdditions'])) || !isNaN(Number(data[i]['pxDeletions'])) || !isNaN(Number(data[i]['pxRevisions']))) {
            adr += data[i]['pxAdditions'] + data[i]['pxDeletions'] + data[i]['pxRevisions']
          }
        }

        // patStatCodes Summary
        if (column === 'patStatCodes') {
          if (!isNaN(Number(data[i]['patStat']))) {
            mt += data[i]['patStat']
          }

          if (!isNaN(Number(data[i]['patStatChanges']))) {
            adr += data[i]['patStatChanges']
          }
        }

        // pooCodes Summary
        if (column === 'pooCodes') {
          if (!isNaN(Number(data[i]['poo']))) {
            mt += data[i]['poo']
          }

          if (!isNaN(Number(data[i]['pooChanges']))) {
            adr += data[i]['pooChanges']
          }
        }

        // poaCodes Summary
        if (column === 'poaCodes') {
          if (!isNaN(Number(data[i]['poaNoRecommendations'])) || !isNaN(Number(data[i]['poaRecommendations']))) {
            mt += data[i]['poaNoRecommendations'] + data[i]['poaRecommendations']
          }

          if (!isNaN(Number(data[i]['poaRecommendations']))) {
            adr += data[i]['poaRecommendations']
          }
        }

        // dx table / psi / qm accuracy rate
        if (columnArray.label === 'Accuracy Rate') {
          let noRec = !isNaN(Number(data[i]['numOfNoRec'])) ? data[i]['numOfNoRec'] : 0
          let additions = !isNaN(Number(data[i]['numOfAdditions'])) ? data[i]['numOfAdditions'] : 0
          let deletions = !isNaN(Number(data[i]['numOfDeletions'])) ? data[i]['numOfDeletions'] : 0
          let revisions = this.isPriDxGrouping()
            ? this.priDxRevisionCount(data[i])
            : (!isNaN(Number(data[i]['numOfRevisions'])) ? data[i]['numOfRevisions'] : 0)

          mt += noRec + additions + deletions + revisions
          adr += additions + deletions + revisions
        }

        // dx table poa accuracy rate
        if (columnArray.label === 'POA Accuracy Rate') {
          if (!isNaN(Number(data[i]['numOfPoaNoRec'])) || !isNaN(Number(data[i]['numOfPoaRec']))) {
            mt += data[i]['numOfPoaNoRec'] + data[i]['numOfPoaRec']
          }

          if (!isNaN(Number(data[i]['numOfPoaRec']))) {
            adr += data[i]['numOfPoaRec']
          }
        }
      }

      return mt || adr ? this.calculatePercentages(mt, adr) : 'N/A'
    },
    totalSummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)

      return response
    },
    totalHACSummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = curr[column]
        if (value) {
          return total + 1
        } else {
          return total
        }
      }, 0)

      return response
    },
    totalMoneySummary(column, data, index) {
      let response = data.reduce((total, curr) => {
        const value = Number(curr[column])
        if (!isNaN(value)) {
          return total + curr[column]
        } else {
          return total
        }
      }, 0)
      return this.moneyFormatter(response)
    },
    calculatePercentages(masterTotal, adrTotal) {
      let response = masterTotal === null || masterTotal === 0 ? 0 : 1 - adrTotal / masterTotal
      return `${(response * 100).toFixed(2)}%`
    },
    checkPercentValues(column, scope) {
      let response = false
      switch (column) {
        case 'Total DRGs':
          if (!scope.row.totalRecords && !scope.row.drgChanges && !scope.row.drgChanges) {
            response = true
          }
          break
        case 'Total Codes':
          if (!scope.row.dxNoRec && !scope.row.pxNoRec && !scope.row.dxAdditions && !scope.row.pxAdditions && !scope.row.dxDeletions && !scope.row.pxDeletions && !scope.row.dxRevisions && !scope.row.pxRevisions) {
            response = true
          }
          break
        case 'ICD-10 CM Codes':
          if (!scope.row.dxNoRec && !scope.row.dxAdditions && !scope.row.dxDeletions && !scope.row.dxRevisions) {
            response = true
          }
          break
        case 'ICD-10 PCS Codes':
          if (!scope.row.pxNoRec && !scope.row.pxAdditions && !scope.row.pxDeletions && !scope.row.pxRevisions) {
            response = true
          }
          break
        case 'Patient Status Codes':
          if (!scope.row.patStatChanges && !scope.row.patStat) {
            response = true
          }
          break
        case 'Point of Origin Codes':
          if (!scope.row.poo && !scope.row.pooChanges) {
            response = true
          }
          break
        case 'POA Indicators':
          if (!scope.row.poaNoRecommendations && !scope.row.poaRecommendations) {
            response = true
          }
          break
        case 'dx cmCodes':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec && !scope.row.numOfRevisions) {
            response = true
          }
          break
        case 'dx poaCodes':
          if (!scope.row.numOfPoaRec && !scope.row.numOfPoaNoRec) {
            response = true
          }
          break
        case 'px pcsCodes':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec && !scope.row.numOfRevisions) {
            response = true
          }
          break
        case 'qmpsi accuracy':
          if (!scope.row.numOfAdditions && !scope.row.numOfDeletions && !scope.row.numOfNoRec) {
            response = true
          }
          break
      }

      return response
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSortChange({ prop, order }) {
      this.sortProp = prop
      this.sortOrder = order
      this.currentPage = 1
    },
    sortData(data) {
      if (!this.sortProp || !this.sortOrder) return data
      const sorted = [...data]
      const modifier = this.sortOrder === 'ascending' ? 1 : -1
      sorted.sort((a, b) => {
        const valA = a[this.sortProp]
        const valB = b[this.sortProp]
        if (valA == null && valB == null) return 0
        if (valA == null) return 1
        if (valB == null) return -1
        if (typeof valA === 'string') return valA.localeCompare(valB) * modifier
        return (valA - valB) * modifier
      })
      return sorted
    },
    getBedSizeValue(groupKey, value, prop, allData, table = '') {
      let response = '—'

      if (this.comparisonAccounts.length) {
        let index

        switch (table) {
          case 'dx':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By Dx') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By Dx')
            break
          case 'sdoh':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === (this.grouping === '24' ? 'By Pri Dx' : 'By SDOH Dx')) : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === (this.grouping === '24' ? 'By Pri Dx' : 'By SDOH Dx'))
            break
          case 'cc':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By CC') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By CC')
            break
          case 'mcc':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By MCC') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By MCC')
            break
          case 'hac':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By HAC') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By HAC')
            break
          case 'hcc':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By HCC') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By HCC')
            break
          case 'hccv28':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By HCC V28') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By HCC V28')
            break
          case 'px':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By PCS') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By PCS')
            break
          case 'qmMortality':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By QM Mortality') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By QM Mortality')
            break
          case 'qmReadmission':
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By QM Readmission') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By QM Readmission')
            break
          default:
            index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review')
        }

        // if (table === 'dx') {
        //   index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By Dx') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By Dx')
        // } else if (table === 'px') {
        //   index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review' && x.title === 'By Px') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review' && x.title === 'By Px')
        // } else {
        //   index = allData ? this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient all review') : this.comparisonAccounts.findIndex(x => x.groupKey === groupKey && x.type === 'inpatient bedsize review')
        // }

        if (index !== -1) {
          let found = {}
          if (groupKey === 'cliName' || groupKey === 'projectName') {
            found = this.comparisonAccounts[index].data[0]
          } else {
            found = this.comparisonAccounts[index].data.find(x => x[groupKey] === value)
          }
          if (found) {
            let percents = ['totalDRGs', 'totalDRGNoQuery', 'totalCodes', 'cmCodes', 'pcsCodes', 'patStatCodes', 'pooCodes', 'poaCodes', 'accuracy', 'accuracyRate']
            let money = ['reimbDiff']
            response = found[prop]
            // display formats
            if (percents.some(x => x === prop)) {
              response = `${(found[prop] * 100).toFixed(2)}%`
            }

            if (money.some(x => x === prop)) {
              response = this.moneyFormatter(found[prop])
            }
          }
          return response
        }
      }
      return response
    },
    isCodeGrouping() {
      return false
    },
    convertHccs(delimited) {
      if (delimited) {
        let retArray = delimited.split('-')
        return retArray
      } else {
        return []
      }
    },
    getHccTitle(id) {
      if (id) {
        let data = []
        let ipIndex = this.reviewDashboardData.findIndex(x => x.type === 'inpatient') > -1 ? this.reviewDashboardData.findIndex(x => x.type === 'inpatient') : null
        let grouping = 'HCCs'
        let groupIndex = this.reviewDashboardData[ipIndex].largeStats.findIndex(x => x.title === grouping)
        data = this.reviewDashboardData[ipIndex].largeStats.some(x => x.title === grouping) ? this.reviewDashboardData[ipIndex].largeStats[groupIndex].data : []

        let filteredList = data.filter(a => a.hccId === id)
        if (filteredList[0]) {
          return filteredList[0].description
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    openUrl(href) {
      window.open(href, '_blank')
    },
    formatDate(date) {
      return format(parseISO(date), 'MM/dd/yyyy')
    }
  },
  created: function() {
    this._summaryHandlers = []
  },
  mounted() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  updated() {
    this.$nextTick(() => {
      this.attachSummaryClickHandlers()
    })
  },
  beforeDestroy() {
    this.cleanupSummaryHandlers()
  },
  watch: {
    grouping() {
      this.currentPage = 1
      this.sortProp = ''
      this.sortOrder = ''
    },
    reviewDashboardData: {
      handler() {
        this.$nextTick(() => {
          let tableRef = this.getActiveTableRef()
          if (tableRef && this.$refs[tableRef]) {
            this.$refs[tableRef].doLayout()
          }
          this.$nextTick(() => {
            this.attachSummaryClickHandlers()
          })
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'comparisonAccounts']),
    coderTableData() {
      return this.getTableData('By Coder')
    },
    coderTrendingTableData() {
      return this.getTableData('By Coder Trending')
    },
    cdiStaffTableData() {
      return this.getTableData('By CDI Staff')
    },
    drgTableData() {
      return this.getTableData('By DRGs')
    },
    patientTypeTableData() {
      return this.getTableData('By Patient Type')
    },
    reasonTableData() {
      return this.getTableData('By Reason')
    },
    facilityTableData() {
      return this.getTableData('By Facility')
    },
    projectTableData() {
      return this.getTableData('By Project')
    },
    soiTableData() {
      return this.getTableData('SOI')
    },
    romTableData() {
      return this.getTableData('ROM')
    },
    dxTableData() {
      return this.getTableData('By Dx')
    },
    sdohTableData() {
      return this.getTableData(this.grouping === '24' ? 'By Pri Dx' : 'By SDOH Dx')
    },
    ccTableData() {
      return this.getTableData('By CC')
    },
    mccTableData() {
      return this.getTableData('By MCC')
    },
    hacTableData() {
      return this.getTableData('By HAC')
    },
    hccTableData() {
      return this.getTableData('By HCC')
    },
    hccV28TableData() {
      return this.getTableData('By HCC V28')
    },
    pxTableData() {
      return this.getTableData('By PCS')
    },
    hccListTableData() {
      return this.getTableData('HCCs')
    },
    psiTableData() {
      return this.getTableData('By PSI')
    },
    qmMortalityTableData() {
      return this.getTableData('By QM Mortality')
    },
    qmReadmissionTableData() {
      return this.getTableData('By QM Readmission')
    },
    serviceLineTableData() {
      return this.getTableData('By Service Line')
    },
    coderTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTableData.slice(from, to)
    },
    coderTrendingTablePagination() {
      let length = this.coderTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.coderTrendingTableData.slice(from, to)
    },
    cdiStaffTablePagniation() {
      let length = this.cdiStaffTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.cdiStaffTableData.slice(from, to)
    },
    drgTablePagination() {
      let length = this.drgTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.drgTableData.slice(from, to)
    },
    patientTypeTablePagination() {
      let length = this.patientTypeTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.patientTypeTableData.slice(from, to)
    },
    reasonTablePagination() {
      let length = this.reasonTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.reasonTableData.slice(from, to)
    },
    facilityTablePagination() {
      let length = this.facilityTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.facilityTableData.slice(from, to)
    },
    projectTablePagination() {
      let length = this.projectTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.projectTableData.slice(from, to)
    },
    dxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.dxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.dxTableData).slice(from, to)
    },
    sdohTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.sdohTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.sdohTableData).slice(from, to)
    },
    ccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.ccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.ccTableData).slice(from, to)
    },
    mccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.mccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.mccTableData).slice(from, to)
    },
    hacTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hacTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hacTableData).slice(from, to)
    },
    hccTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccTableData).slice(from, to)
    },
    hccV28TablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.hccV28TableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.hccV28TableData).slice(from, to)
    },
    pxTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.pxTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.pxTableData).slice(from, to)
    },
    psiTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.psiTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.psiTableData).slice(from, to)
    },
    qmMortalityTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.qmMortalityTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.qmMortalityTableData).slice(from, to)
    },
    qmReadmissionTablePagination() {
      let localItemsPerPage = this.isCodeGrouping() ? this.codeItemsPerPage : this.itemsPerPage
      let length = this.qmReadmissionTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * localItemsPerPage + 1
      let to = this.currentPage * localItemsPerPage
      return this.sortData(this.qmReadmissionTableData).slice(from, to)
    },
    serviceLineTablePagination() {
      let length = this.serviceLineTableData.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.serviceLineTableData.slice(from, to)
    },
    paginationTotal() {
      let length = 0
      switch (this.grouping) {
        case '1':
          length = this.coderTableData.length
          break
        case '19':
          length = this.coderTrendingTableData.length
          break
        case '2':
          length = this.cdiStaffTableData.length
          break
        case '3':
          length = this.drgTableData.length
          break
        case '4':
          length = this.patientTypeTableData.length
          break
        case '6':
          length = this.reasonTableData.length
          break
        case '7':
          length = this.facilityTableData.length
          break
        case '23':
          length = this.projectTableData.length
          break
        case '8':
          length = this.dxTableData.length
          break
        case '18':
          length = this.sdohTableData.length
          break
        case '24':
          length = this.sdohTableData.length
          break
        case '9':
          length = this.pxTableData.length
          break
        case '10':
          length = this.ccTableData.length
          break
        case '11':
          length = this.mccTableData.length
          break
        case '12':
          length = this.hacTableData.length
          break
        case '13':
          length = this.hccTableData.length
          break
        case '17':
          length = this.hccV28TableData.length
          break
        case '14':
          length = this.psiTableData.length
          break
        case '15':
          length = this.qmMortalityTableData.length
          break
        case '16':
          length = this.qmReadmissionTableData.length
          break
        case '20':
          length = this.serviceLineTableData.length
          break
      }
      return length
    },
    paginationSummaries() {
      let data = []
      switch (this.grouping) {
        case '1':
          data = this.coderTableData
          break
        case '19':
          data = this.coderTrendingTableData
          break
        case '2':
          data = this.cdiStaffTableData
          break
        case '3':
          data = this.drgTableData
          break
        case '4':
          data = this.patientTypeTableData
          break
        case '6':
          data = this.reasonTableData
          break
        case '7':
          data = this.facilityTableData
          break
        case '23':
          data = this.projectTableData
          break
        case '8':
          data = this.dxTableData
          break
        case '18':
          data = this.sdohTableData
          break
        case '24':
          data = this.sdohTableData
          break
        case '9':
          data = this.pxTableData
          break
        case '10':
          data = this.ccTableData
          break
        case '11':
          data = this.mccTableData
          break
        case '12':
          data = this.hacTableData
          break
        case '13':
          data = this.hccTableData
          break
        case '17':
          data = this.hccV28TableData
          break
        case '14':
          data = this.psiTableData
          break
        case '15':
          data = this.qmMortalityTableData
          break
        case '16':
          data = this.qmReadmissionTableData
          break
        case '20':
          data = this.serviceLineTableData
          break
      }
      return data
    },
    codeGroupingAllData() {
      let data = []
      switch (this.grouping) {
        case '8':
          data = this.dxTableData
          break
        case '18':
          data = this.sdohTableData
          break
        case '24':
          data = this.sdohTableData
          break
        case '9':
          data = this.pxTableData
          break
        case '10':
          data = this.ccTableData
          break
        case '11':
          data = this.mccTableData
          break
        case '12':
          data = this.hacTableData
          break
        case '13':
          data = this.hccTableData
          break
        case '17':
          data = this.hccV28TableData
          break
        case '14':
          data = this.psiTableData
          break
        case '15':
          data = this.qmMortalityTableData
          break
        case '16':
          data = this.qmReadmissionTableData
          break
      }
      return data
    }
  }
}
</script>

<style scoped>
.qmDisclaimer {
  font-size: 10px;
  font-style: italic;
  margin: 5px 0px 0px 0px;
  color: #909399;
}
.priDxDisclaimer {
  font-size: 11px;
}
/* Element UI: sort changes header height but does not rerun layout; body-wrapper keeps a stale
   inline height so header + body + summary exceeds fixed height and the footer is clipped.
   Scoped to #ipData so every el-table in this view gets flex body without per-table classes. */
#ipData >>> .el-table {
  display: flex;
  flex-direction: column;
}
#ipData >>> .el-table__header-wrapper,
#ipData >>> .el-table__footer-wrapper {
  flex-shrink: 0;
}
#ipData >>> .el-table__body-wrapper {
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
}
</style>
